import logo from '../images/logo.svg'

export const LOGO = logo
